// The quiet line under a product's share buttons: placing an order is
// accepting the Terms of Use and, for a merchant's product, the merchant's
// own terms (terms §3.7, on its "About the seller" page).
import React from "react"
import { twMerge } from "tailwind-merge"
import useT from "../hooks/useT"

export default function OrderTermsNote({ product, className = "" }) {
  const t = useT()
  const link = "underline underline-offset-2 hover:text-text"
  return (
    <p className={twMerge("m-0 text-center text-[12px] leading-relaxed text-text_secondary", className)} data-testid="order-terms-note">
      {t`By placing an order you agree to`}{" "}
      <a href="/terms-of-use" target="_blank" rel="noreferrer" className={link}>
        {t`the Terms of Use`}
      </a>
      {product?.publisherSlug && (
        <>
          {" "}
          {t`and to the`}{" "}
          <a href={`/seller/${product.publisherSlug}/about`} className={link}>
            {t`seller's terms`}
          </a>
        </>
      )}
      .
    </p>
  )
}
